// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2NlbL","info":"PatientInfo_info__3D31u"};